import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { CreateResidentialAmenityForm } from '@/features/ResidentialAmenities/CreateResidentialAmenityForm/ui/CreateResidentialAmenityForm'
import { useTranslation } from 'react-i18next'

type CreateResidentialAmenityModalProps = {
  dialogProps: AlertDialogProps
  onCloseModal: () => void
}

export const CreateResidentialAmenityModal: FC<CreateResidentialAmenityModalProps> = props => {
  const { dialogProps, onCloseModal } = props
  const { t } = useTranslation(['amenity'])
  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh]'}>
        <DialogHeader>
          <DialogTitle>{t('amenity:create_amenity_title')}</DialogTitle>
          <CreateResidentialAmenityForm onCloseModal={onCloseModal} />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
